import React, { useRef, useState, useEffect } from "react";
import img1 from "../../../assets/bgImage.jpeg";
import img2 from "../../../assets/Noorain sir.JPG";
import img3 from "../../../assets/Anas sir.jpeg";
import img4 from "../../../assets/Ashish sir.jpeg";
import img5 from "../../../assets/Nishant sir.jpeg";
import img6 from "../../../assets/Arish sir.jpeg";
import img7 from "../../../assets/Harendra sir.jpeg";
import img8 from "../../../assets/Iqbal sir.jpeg";
import img9 from "../../../assets/Rakhi mam.jpeg";
import img10 from "../../../assets/Abhishek sir.jpeg";

function Testimonial() {
  const containerRef = useRef(null);
  const [index, setIndex] = useState(0);

  const cardWidth = 340;
  const gap = 16;
  const slideWidth = cardWidth + gap;

  const testimonials = [
    { img: img2, name: "Mohd Noorain Siddiqui", title: "Senior Director – Operations", text: "Business Process Optimization | Strategic Operations Management | Performance & Productivity Enhancement", skills: "Operations | Strategy | Optimization" },
    { img: img3, name: "Anas Ahmad", title: "Associate Director – People & Process", text: "Strategic Workforce Planning | Operational Excellence | Organizational Development & Process Improvement", skills: "Workforce planning | Operational Excellence" },
    { img: img4, name: "Ashish Maurya", title: "Mentorship & Employee Development Head – Cybredge Pvt. Ltd.", text: "React.js Frontend Developer", skills: "React.js | JavaScript | Frontend" },
    { img: img5, name: "Nishant Srivastava", title: "VP-coding (vice president)", text: "Senior Software Engineer | Tech lead 2 | Gold Medalist.", skills: "PHP | Python | Java | MongoDB | MySQL" },
    { img: img6, name: "Mohd Arish Jameel", title: "Application Development Associate", text: "Senior Application Support Analyst", skills: "RPA | Intelligent Automation | DevOps" },
    { img: img7, name: "Harendra Negi", title: "Security Engineering Lead", text: "Cyber Security Engineer", skills: "Application Security | Pentesting | Red Teaming | Python | Ethical Hacking | Security Engineering" },
    { img: img8, name: "D.Iqbal", title: "Social Media Manager", text: "Senior Developer | Social Media Expert | Business Advicer", skills: "Social media Management" },
    { img: img9, name: "Rakhi Singh", title: "Senior HR Manager", text: "Human Resource Strategist | Talent Acquisition Expert | Employee Relations Specialist", skills: "Human resource strategy | Talent Acquisition" },
    { img: img10, name: "Abhishek Srivastava", title: "Senior Java Developer", text: "Java Application Development | Spring & Spring Boot | Microservices Architecture | REST APIs | Database Design & Optimization", skills: "Expert in Java with strong experience in Spring Boot based microservices | RESTful systems | Database optimizattion" },
  ];

  const allTestimonials = [...testimonials, ...testimonials];

  const nextSlide = () => setIndex((prev) => prev + 1);
  const prevSlide = () =>
    setIndex((prev) => (prev === 0 ? testimonials.length : prev - 1));

  useEffect(() => {
    if (index === testimonials.length) {
      setTimeout(() => {
        containerRef.current.style.transition = "none";
        setIndex(0);
      }, 500);
    } else {
      containerRef.current.style.transition = "transform 0.5s ease-in-out";
    }
  }, [index, testimonials.length]);

  return (
    <div
      className="min-h-screen py-16 px-5 overflow-hidden relative font-poppins"
      style={{
        backgroundImage: `url(${img1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/60 -z-10" />

      {/* ===== TOP CONTENT ===== */}
      <div className="text-center text-white max-w-4xl mx-auto mb-12">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-[3px] mb-4 uppercase">
          Testimonials
        </h2>

        <div className="w-16 h-[3px] bg-rose-400 mx-auto mb-8"></div>

        <h5 className="text-xl font-medium mb-2">What Our Clients Say</h5>

        <p className="text-gray-200 text-sm md:text-base">
          Trusted by Businesses Worldwide · Real Feedback · Real Results.
        </p>
        <p className="text-gray-200 text-sm md:text-base">
          Why Our Clients Love Working With Us
        </p>
        <p className="text-gray-200 text-sm md:text-base mb-4">
          Client Success Stories
        </p>

        <b className="block mt-4 text-lg">Introduction:-</b>

        <p className="mt-4 text-gray-300 leading-relaxed">
          At <b className="text-white">CYBREDGE PRIVATE LIMITED</b>, we believe in
          building long-term partnerships with our clients by delivering
          reliable, high-quality and future-ready IT solutions.
        </p>

        <p className="mt-2 text-gray-300">
          Here are some genuine experiences shared by our clients.
        </p>

        <p className="mt-2 text-gray-400 italic">
          “Amazing support and excellent quality!” “Fast delivery, great pricing
          and reliable team!” “Professional, responsive and highly skilled!”
        </p>

        <p className="mt-1 text-gray-400 italic">
          “Outstanding service — highly recommended!”
        </p>
      </div>

      {/* ===== SLIDER ===== */}
      <div className="relative overflow-hidden w-full">
        <button
          onClick={prevSlide}
          className="absolute left-2 top-1/2 -translate-y-1/2 z-10
          bg-white/70 hover:bg-white w-10 h-10 rounded-full
          flex items-center justify-center text-xl font-bold shadow-md"
        >
          &#10094;
        </button>

        <div
          ref={containerRef}
          className="flex gap-4"
          style={{
            transform: `translateX(-${index * slideWidth}px)`,
          }}
        >
          {allTestimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-xl p-6
              w-[340px] min-w-[340px] flex-shrink-0"
            >
              <img
                src={t.img}
                alt={t.name}
                className="w-20 h-20 rounded-full object-cover border-4 border-gray-200 mb-4"
              />

              <h3 className="text-lg font-semibold text-gray-800">
                {t.name}
              </h3>

              <h4 className="text-sm text-gray-500 italic mb-3">
                {t.title}
              </h4>

              <div className="text-yellow-400 text-xl mb-3">★★★★★</div>

              <p className="text-gray-600 italic text-sm leading-relaxed">
                "{t.text}"
              </p>

              <p className="text-gray-700 text-sm mt-3 leading-relaxed">
                <b>Skills:</b> {t.skills}
              </p>
            </div>
          ))}
        </div>

        <button
          onClick={nextSlide}
          className="absolute right-2 top-1/2 -translate-y-1/2 z-10
          bg-white/70 hover:bg-white w-10 h-10 rounded-full
          flex items-center justify-center text-xl font-bold shadow-md"
        >
          &#10095;
        </button>
      </div>
    </div>
  );
}

export default Testimonial;